export default __webpack_public_path__ + "static/media/stop-glyph-16px.15e20fa8.svg";